<template>
  <div class="vtMain">
    <!-- <button style="z-index: 255;" @click="rfcShowPopUp = !rfcShowPopUp">Open RFC</button> -->
    <input class="vtSliderV" ref="vtSliderV" type="range" min="0" max="500" value="270" @input="vtResize('vertical')" />
    <div class="vtDisplayMain">
      <div class="vtTopMain">
        <div class="vtControlsMain">
          <Menus :menu="vtMapMenuData" @menuClicked="vtMapMenuClicked" />
        </div>
        <div class="vtMapMain">
          <div class="vtMap">
            <GMapV2 class="gMapMain" :mOptions="mOptions" :mMarker.sync="mMarker" :mCenter.sync="mCenter" :mZoom.sync="mZoom" :mDirections.sync="mDirections" @infoBtnClick="vtMapBtn" />
            <div class="vtLegendBox" v-if="mLegendShow" :style="{ 'bottom' : ((routeView * 35) + (mRefreshShow * 60)) + 5 + 'px' }">
              <div class="vtLegendItem"> <img class="veLegendIcon" src="https://dsmapi.logistics.systems/dsm6gicons/TruckOn.png" /> <div class="vtLegendTitle">In Del/Col</div> </div>
              <div class="vtLegendItem"> <img class="veLegendIcon" src="https://dsmapi.logistics.systems/dsm6gicons/TruckOff.png" /> <div class="vtLegendTitle">No Job</div> </div>
              <div class="vtLegendItem"> <img class="veLegendIcon" src="https://dsmapi.logistics.systems/dsm6gicons/Warehouse.png" /> <div class="vtLegendTitle">RFC Container</div> </div>
            </div>
            <div class="vtRefreshMain" :style="{ 'display' : (!mRefreshShow ? 'none' : 'flex'), 'bottom' : ((routeView * 35) + 5) + 'px' }">
              <div class="vtRefreshTitle">Refresh every: </div>
              <select class="vtRefreshDropdown" ref="vtRefreshDropdown" @change="refreshData" ></select>
            </div>
            <div class="vtMapViewResetMain" v-if="routeView"> <button class="vtMapViewResetBtn" @click="mResetView" >Reset View</button> </div>
            <div class="vtMapPopUpMain" v-if="rfcShowPopUp">
              <div class="vtMapPopUp">
                <div class="vtMapPopUpHeader">Detail Collection
                  <div class="vtMapPopUpControls">
                    <button class="vtMapPopUpBtn" @click="vtMapBtn('Close')">Close</button>
                    <button class="vtMapPopUpBtn" @click="vtMapBtn('Save')">Save</button>
                  </div>
                </div>
                <div class="vtMapPopUpContent">
                  <div class="vtMapPopUpContentDetails">
                    <div class="vtMapPopUpContentCol">
                      <div class="vtMapPopUpContentRow"> <div class="vtMapPopUpContentTitle">Consignment No</div> <div class="vtMapPopUpContentValue">{{rfcSelectedC['ConsignmentNo']}}</div> </div>
                      <div class="vtMapPopUpContentRow"> <div class="vtMapPopUpContentTitle">Container No</div> <div class="vtMapPopUpContentValue">{{rfcSelectedC['ContainerNo']}}</div> </div>
                      <div class="vtMapPopUpContentRow"> <div class="vtMapPopUpContentTitle">SzTyp / Hdg / Del</div> 
                        <div class="vtMapPopUpContentValue"> {{rfcSelectedC['Cont Size'] + rfcSelectedC['Cont Type'] + ' / ' + rfcSelectedC['Handling Type'] + ' / ' + rfcSelectedC['Delivery Type']}} </div>
                      </div>
                      
                    </div>
                    <div class="vtMapPopUpContentCol">
                      <Input placeholder="Seal No" :inputValue.sync="rfcSealNo"/>
                      <RemarksBox title="Remarks" :text.sync="rfcRemarks"/>
                    </div>
                  </div>
                  <div class="vtMapAssignMain">
                    <div class="vtMapAssign">
                      <div class="vtMapAssignTitle">Assign PM</div>
                      <div class="vtMapAssignContent">
                        <Dropdown placeholder="Prime Mover" :items.sync="rfcPM" itemKey="desc" :selectedObject.sync="rfcPMSelected" @selected="rfcAssign"
                          :isRequired="true" :errorMessage="rfcErrors['errorPM']" />
                        <Validator vldTitle="Availability" :vldValue="!rfcPMSelected ? '-' : !rfcPMSelected['Availability'] ? '-' : rfcPMSelected['Availability']"
                          :vldValid="!rfcPMSelected ? false : !rfcPMSelected['Availability'] ? false : (rfcPMSelected['Availability'] == 1)" />
                        <Validator vldTitle="Road Tax" :vldValue="!rfcPMSelected ? '-' : !rfcPMSelected['RoadTaxExpiryDate'] ? '-' : rfcPMSelected['RoadTaxExpiryDate']"
                          :vldValid="!rfcPMSelected ? false : !rfcPMSelected['RoadTaxExpiryDate'] ? false : (formatStringtoDate(rfcPMSelected['RoadTaxExpiryDate']) >= Date.now())" />
                        <Validator vldTitle="Inspection" :vldValue="!rfcPMSelected ? '-' : !rfcPMSelected['InspectionDate'] ? '-' : rfcPMSelected['InspectionDate']"
                          :vldValid="!rfcPMSelected ? false : !rfcPMSelected['InspectionDate'] ? false : (formatStringtoDate(rfcPMSelected['InspectionDate']) >= Date.now())" />
                        <Validator vldTitle="Permit" :vldValue="!rfcPMSelected ? '-' : !rfcPMSelected['PermitExpiryDate'] ? '-' : rfcPMSelected['PermitExpiryDate']"
                          :vldValid="!rfcPMSelected ? false : !rfcPMSelected['PermitExpiryDate'] ? false : (formatStringtoDate(rfcPMSelected['PermitExpiryDate']) >= Date.now())" />
                        <Input placeholder="Trailer No" :inputValue.sync="rfcTrailerNo"/>
                      </div>
                    </div>
                    <div class="vtMapAssign" style="margin: 0 5px">
                      <div class="vtMapAssignTitle">Assign Driver</div>
                      <div class="vtMapAssignContent">
                        <Dropdown placeholder="Driver" :items.sync="rfcDriver" itemKey="desc" :selectedObject.sync="rfcDriverSelected" @selected="rfcAssign"
                          :isRequired="true" :errorMessage="rfcErrors['errorDriver']" />
                        <Validator vldTitle="Driver License" :vldValue="!rfcDriverSelected ? '-' : !rfcDriverSelected['DrvLicenseExpiryDate'] ? '-' : rfcDriverSelected['DrvLicenseExpiryDate']"
                          :vldValid="!rfcDriverSelected ? false : !rfcDriverSelected['DrvLicenseExpiryDate'] ? false : (formatStringtoDate(rfcDriverSelected['DrvLicenseExpiryDate']) >= Date.now())" />
                        <Validator vldTitle="Badge License" :vldValue="!rfcDriverSelected ? '-' : !rfcDriverSelected['BadgeLicenseExpiryDate'] ? '-' : rfcDriverSelected['BadgeLicenseExpiryDate']"
                          :vldValid="!rfcDriverSelected ? false : !rfcDriverSelected['BadgeLicenseExpiryDate'] ? false : (formatStringtoDate(rfcDriverSelected['BadgeLicenseExpiryDate']) >= Date.now())" />
                        <Validator vldTitle="Port Pass" :vldValue="!rfcDriverSelected ? '-' : !rfcDriverSelected['PortPassExpiryDate'] ? '-' : rfcDriverSelected['PortPassExpiryDate']"
                          :vldValid="!rfcDriverSelected ? false : !rfcDriverSelected['PortPassExpiryDate'] ? false : (formatStringtoDate(rfcDriverSelected['PortPassExpiryDate']) >= Date.now())" />
                      </div>

                    </div>
                    <div class="vtMapAssign">
                      <div class="vtMapAssignTitle">Assign Movement</div>
                      <div class="vtMapAssignContent">
                        <div class="vtMapAssignContent">
                          <Dropdown placeholder="Movement" :items.sync="rfcMovement" itemKey="desc" :isRequired="true" 
                            :selectedObject.sync="rfcMovementSelected" @selected="rfcAssign" :errorMessage="rfcErrors['errorMovement']" />
                          <Dropdown placeholder="From" :items="vtPersistentData['assignFromTo']" itemKey="desc"
                            :selectedObject.sync="rfcFromSelected" @selected="rfcAssign"/>
                          <Dropdown placeholder="To" :items="vtPersistentData['assignFromTo']" itemKey="desc"
                            :selectedObject.sync="rfcToSelected" @selected="rfcAssign"/>
                          <DateTime title="ETD" :value.sync="rfcETD" />
                          <DateTime title="ETA" :value.sync="rfcETA" />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="vtMapPopUpMsgMain"> <div class="vtMapPopUpMsg" :style="{ 'background-color' : (!rfcMsg['color'] ? '' : rfcMsg['color'])}">{{rfcMsg['msg']}}</div> </div>
              </div>
            </div>
          </div>
          <div class="vtSliderHBarH" ref="vtSliderHBarH" style="margin: 0 5px;"></div>
          <div class="vtTableMain" ref="vtTableMain" style="width: 38%;">
            <Tabulator class="vtTable" tableTitle="Vehicle List" tableID="vtTableVehicle" :tableData="vtVehicleData" multiSelect="1"
              :frozenColumn="vtFrozen" :additionalColumn="vtAddColumnVehicle" :hideColumns="vtHideColumns" @cellButtonClick="cellBtnVehicle" @rowSelected="rowSelectVehicle" />
          
            <div class="vtTableMainLoader" v-if="vtLoaderText">
              <div class="vtTableMainLoaderText">{{vtLoaderText}}</div>
            </div>
          </div>
          <input class="vtSliderH" ref="vtSliderH" type="range" min="0" max="500" value="250" @input="vtResize('horizontal')" />
        </div>
      </div>

      <div class="vtSliderHBarV"></div>

      <div class="vtBottomMain" ref="vtBottomMain" style="height: 46%;">
        <div class="vtBottomMenu">
          <Menus :menu="vtMenuData" @menuClicked="vtMultiMenuClicked" />
        </div>
        <div class="vtMultiTableMain">
          <div class="vtMultiTable" v-for="(vm, vmI) in vtMenuData.filter((m) => { return m['show']})" :key="vm"
              :style="((vmI > 0) && (vtMenuData.filter((m) => { return m['show']; }).length > 1) ? { 'border-left': 'solid 3px #000' } : '')">
            <MiniTab class="vtMTable" v-if="vm['show']" :tableTitle="vm['title'] + ' List'" :tableID="'vtMTable' + vmI" :tableData.sync="vm['data']" multiSelect="1"
              @cellButtonClick="vtMCellClick($event, vm['title'])" @rowSelected="vtMRowClick($event, vm['title'])" :additionalColumn.sync="vm['additionalCol']"
              :mtLoad.sync="vm['showLoad']" :mtPage.sync="vm['pageTitle']" :mtPopUp.sync="vm['showPopup']" :mtSelectedRow.sync="vm['selectedRow']"
              @mtClose="vtMBtn('close', $event)"/>
          </div>
          <div class="vtMultiTableNoSelect" v-if="(vtMenuData.filter((m) => { return m['show']})).length <= 0"> <div class="vtMultiTableNoSelectTitle">No Table Selected</div> </div>
          <!--<div class="vtMultiTable" v-for="(vm, vmI) in vtMenuData.filter((m) => { return m['show']})" :key="vm"
               :style="((vmI > 0) && (vtMenuData.filter((m) => { return m['show']; }).length > 1) ? { 'border-left': 'solid 3px #000' } : '')">
            <Tabulator class="vtMTable" :tableTitle="vm['title']" :tableID="'vtMTable' + vmI" :tableData.sync="vm['data']" multiSelect="1"
                       @cellButtonClick="cellBtnPending" @rowSelected="rowSelectPending" v-if="vm['show']" />
            <div class="vtMPopUpMain" v-if="vm['showPopup']">
              <div class="vtMPopUp">
                <div class="vtMPopUpHeader">
                  {{vm['title']}}
                  <div class="vtMPopUpControls">
                    <button class="vtMPopUpBtn" @click="vtMBtn('Close', vm['title'])">Close</button>
                    <button class="vtMPopUpBtn">Save</button>
                  </div>
                </div>
                <div class="vtMPopUpContent">
                  Content
                </div>
              </div>
            </div>
            <div class="vtMLoadMain" v-if="vm['showLoad']"> <div class="vtMLoadTitle">Getting Data<div class="vtMLoad"></div></div>   </div>
            <div class="vtMErrorMain" v-if="vm['showError']">
              <div class="vtMErrorContent">
                <div class="vtMErrorTitle">ERROR</div>
                <div class="vtMErrorMsg">{{vm['errorMsg']}}</div>
              </div>
            </div>
          </div>
          <div class="vtMultiTableNoSelect" v-if="(vtMenuData.filter((m) => { return m['show']})).length <= 0"> <div class="vtMultiTableNoSelectTitle">No Table Selected</div> </div>-->
        </div>
      </div>
    </div>

    <!--<EntryPopup newStyle="true" title="Pending Trips" :show="vtPTShow" :content="vtPTData"/>-->
    <Loader :isVisible="loading" :loadingText="loadText" />
    <div class="assignPopUp" v-if="assignShow"> 
      <AssignV1 class="assignMain" :title="assignTitle" :assignRFC.sync="assignSelected" :assignRFCRaw.sync="assignSelectedRaw" :assignVehicles.sync="vtVehicleData"
        @assignClose="assignBtn('close')" @assignSave="assignBtn('save')"/>
    </div>
    <!-- Pending Trips Window -->
    <div class="vtPTMain" v-if="vtPTShow">
      <div class="vtPTDisplay">
        <div class="vtPTHeader" :style="(!vtPTSelected['Staff_Status']) ? 'backgroundColor: initial' :  ((vtPTSelected['Staff_Status'] == 'O') ? 'backgroundColor:#fa314a' : 'backgroundColor:#26e07f' )">Pending Trips <button @click="clearPTData">Close</button></div>
        <div class="vtPTInfoMain">
          <div class="vtPTInfoRow"> <div class="vtPTInfoTitle">Vehicle</div> <div class="vtPTInfoValue">{{vtPTSelected['Vehicle']}}</div> </div>
          <div class="vtPTInfoRow"> <div class="vtPTInfoTitle">Driver</div> <div class="vtPTInfoValue"><div v-html="vtPTSelected['Driver']"/></div> </div>
       
        </div>
        <div class="vtPTContent">
          <div v-if="vtPTData.length <= 0">No Data</div>
          <div class="vtPTItem" v-for="pt in vtPTData" :key="pt" v-else>
            <div class="vtPTInfoRow"> <div class="vtPTInfoTitle">{{pt['ContainerNo']}}</div> <div class="vtPTInfoValue">{{pt['ContSize']}}{{pt['ContType']}}</div> </div>
            <div class="vtPTInfoRow"> <div class="vtPTInfoTitle">{{pt['B2BContainerNo']}}</div> <div class="vtPTInfoValue">{{pt['B2BContSize']}}{{pt['B2BContType']}}</div> </div>
            <div class="vtPTInfoRow"> <div class="vtPTInfoTitle">{{pt['ConsignmentNo']}}</div> <div class="vtPTInfoValue">{{pt['MovementType']}}</div> </div>
            <div class="vtPTInfoRow" v-if="pt['B2BConsignmentNo']"> <div class="vtPTInfoTitle">{{pt['B2BConsignmentNo']}}</div> <div class="vtPTInfoValue">{{pt['MovementType']}}</div> </div>
            <div class="vtPTInfoRow"> <div class="vtPTInfoTitle">{{pt['BillToName']}}</div> <div class="vtPTInfoValue">[{{pt['FromArea']}} - {{pt['ToArea']}}]</div> </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';
import GMapV2 from '@/components/GoogleMapV2.vue';
import Tabs from '@/components/Tabs.vue';
import Loader from '@/components/Loader.vue';
import EntryPopup from '@/components/EntryPopup.vue';
import Menus from '@/components/Menus.vue';
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import DateTime from '@/components/DateTimePicker.vue';
import RemarksBox from '@/components/RemarksBox.vue';
import Validator from '@/components/VehicleTracker/SubComponents/Validator.vue';
import MiniTab from '@/components/VehicleTracker/SubComponents/MiniTabulator.vue';
import AssignV1 from '@/components/VehicleTracker/SubComponents/AssignV1.vue';

//Fixed Variables
const defaultpos = { lat: 3.091033, lng: 101.403 };
const defaultzoom = 8;

export default {
  components: {
    Tabulator, GMapV2, Tabs, Loader, EntryPopup, Menus, Input, InputQuery, Dropdown, DateTime, RemarksBox, Validator, MiniTab, AssignV1,
    },
  props: {
    //-------- Assign Props
    assignTitle: { type: String, default: 'Assign Collection' },
    assignShow: { type: Boolean, default: false },
    assignSelected: { type: Object, default: function () { return {}; }},
    assignSelectedRaw: { type: Object, default: function () { return {}; }},

    //-------- Tabulator Props
    vtVehicleData: { type: Array, default: function () { return []; }},
    vtAddColumnVehicle: {
      type: Array, default: function () {
        return [
          { value: 'Show Pending Trips', type: 'button', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-in-transit-64.png', index: 0 },
          { value: 'Show Route', type: 'button', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-location-64.png', index: 1 },
          // { value: 'Show GPS Current Address', type: 'button', icon: 'https://img.icons8.com/ios-glyphs/30/000000/address.png', index: 2}
        ];
      }
    },
    vtHideColumns: {
      type: Array, default: function () {
        return [
          'Latitude', 
          'Longitude',
          'Dep Code',
          'Dep Latitude',
          'Dep Longitude',
          'Dep Company',
          'Dep Company Code',
          'Dest Code',
          'Dest Latitude',
          'Dest Longitude',
          'Dest Company',
          'Dest Company Code',
          'Driver Name',
          'Driver Code',
          'Job No',
        ];
      }
    },
    vtLoaderText: { type: String, default: '' },
    vtFrozen: { type: Array, default: function () { return [ '' ]; }},
    vtPersistentData: { type: Object, default: function () { return {}; } },
    //-------- Map Props
    mMarker: { type: Array, default: function () { return []; } },
    mDirections: { type: Object, default: function () { return { fromlat: 0, fromlng: 0, tolat: 0, tolng: 0 }; } },
    routeView: { type: Boolean, default: false },
    mDirCurrent: { type: Object, default: function () { return {}; } },
    mCenter: { type: Object, default: function () { return defaultpos; } },
    mZoom: { type: Number, default: defaultzoom },
    mOptions: { type: Object, default: function () { return { clickable: true, draggable: false }; } },
    mLegendShow: { type: Boolean, default: false },
    mRefreshTiming: {
      type: Array, default: function () {
        return [
          { desc: '10 seconds', ms: 10000 },
          { desc: '30 seconds', ms: 30000 },
          { desc: '5 minutes', ms: (5 * 60000) },
          { desc: '10 minutes', ms: (10 * 60000) },
          { desc: '30 minutes', ms: (30 * 60000) },
          { desc: '1 hour', ms: (60 * 60000) },
        ];
      }
    },
    mRefreshShow: { type: Boolean, default: false },
    mDefaultRefresh: { type: Object, default: function () { return { desc: '30 minutes', ms: (30 * 60000) }; } },
    mRefreshInterval: { type: Object, default: function () { return {}; } },
    //-------- Pending Trip Props
    vtPTData: { type: Array, default: function () { return []; } },
    vtPTSelected: { type: Object, default: function () { return {}; } },
    vtPTShow: { type: Boolean, default: false },
    //-------- RFC Props
    rfcShowPopUp: { type: Boolean, default: false },
    rfcSelectedC: { type: Object, default: function () { return {}; } },
    rfcPM: { type: Array, default: function () { return []; } }, rfcPMSelected: { type: Object, default: function () { return null; } },
    rfcDriver: { type: Array, default: function () { return []; } }, rfcDriverSelected: { type: Object, default: function () { return null; } },
    rfcMovement: { type: Array, default: function () { return []; } }, rfcMovementSelected: { type: Object, default: function () { return null; } },
    rfcETD: { type: Date, default: function () { return new Date; } },
    rfcETA: { type: Date, default: function () { return new Date; } },
    rfcFromSelected: { type: Object, default: function () { return {}; } },
    rfcToSelected: { type: Object, default: function () { return {}; } },
    rfcErrors: {
      type: Object, default: function () {
        return {
          errorPM: '',
          errorDriver: '',
          errorMovement: '',
        };
      }
    },
    rfcMsg: {
      type: Object, default: function () {
        return {
          msg: '',
          color: '',
        };
      }
    },
    rfcSealNo: { type: String, default: '' },
    rfcTrailerNo: { type: String, default: '' },
    rfcRemarks: { type: String, default: '' },
    //-------- Menus Props
    vtMapMenuData: {
      type: Array, default: function () {
        return [
          { title: 'Show RFC Containers', icon: 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RFC_gray.png' },
          { title: 'Refresh', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png' },
          { title: 'Refresh Interval', icon: 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RefreshTimer.png' },
          { title: 'Legend', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Legend.png' },
        ];
      }
    },
    vtMenuData: {
      type: Array, default: function () {
        return [
          //{ title: 'Delivery', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Delivery.png', show: true, data: [{ 'Status' : 'No Data' }] },
          //{ title: 'Pending Collection', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Pending%20Collection.png', show: true, data: [{ 'Status' : 'No Data' }] },
          //{ title: 'Collection', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Collection.png', show: true, data: [{ 'Status' : 'No Data' }] },
          //{ title: 'Staging Delivery', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Staging%20Delivery.png', show: true, data: [{ 'Status' : 'No Data' }] },
          //{ title: 'Staging Collection', icon: 'https://dsmapi.logistics.systems/dsm6gicons/Staging%20Collection.png', show: true, data: [{ 'Status' : 'No Data' }] },
          //{ title: 'Staging - Internal Diversion 1', icon: '', show: true, data: [{ 'Status' : 'No Data' }] },
          //{ title: 'Staging - Internal Diversion 2', icon: '', show: true, data: [{ 'Status' : 'No Data' }] },
        ];
      }
    },
    //-------- Loader Props
    loading: { type: Boolean, default: false },
    loadText: { type: String, default: 'Loading' },
    //-------- Slider Props
    isDrag: { type: Boolean, default: false },

  },

  // data : {
    
    
  // },

  // created() {
  //   this.clockedOut = '<img src="https://img.icons8.com/fluency-systems-regular/20/000000/attendance-mark--v19.png"/>';
  // },
  async mounted() {
    await this.getReverseGeoCode(3.3719, 101.5811);
    
    this.getRefreshItems();
    this.getMenuItems();
    this.getAssignData();
    this.refreshData();
  },
  methods: {

    getReverseGeoCode : function(lati, long){


      return this.$gmapApiPromiseLazy().then(() => {
        // let coor = input.split(',',2);
        let latlng = {
          lat : lati,
          lng : long,
        };

        return new google.maps.Geocoder().geocode({location : latlng}).then(
          (response) => {
            let temp = [];
            // console.log(response);
            temp = response.results.sort((a,b) => {return b['address_components'].length - a['address_components'].length});
            console.log(temp[0]['formatted_address']);
            // temp.forEach(i => console.log(i['formatted_address']));

            return temp[0]['formatted_address'];
          }).catch((e) =>console.log(e));
      });
           // this.$gmapApiPromiseLazy().then(async () => {

      //   let latlong = {
      //     lat : lati, 
      //     lng : long,
      //   };

      //   let mapData = new google.maps.Geocoder();
      //   let mapArray = mapData.geocode(
      //     {location: latlong}
      //   );
      //   return mapArray;

      // });
      
    },

    //-------- Assign Methods
    assignBtn: async function(btn) {
      switch(btn) {
        case 'close':
          this.assignShow = false;
          this.assignTitle = '';
          this.assignSelected = {};
          this.assignSelectedRaw = {};
          break;
        case 'save':
          break;
      }
    },

    //-------- Vehicle Track Methods
    getLastLocation: async function () {
      // this.loading = true; this.loadText = 'Getting Vehicles';
      this.vtLoaderText = 'Getting Vehicles';
      try {
        console.time();
        var lastlocation = await this.$apiCallV2(`/VehicleTracker/GPS_GetLastLocationVehicleByCategory`);
        
        console.timeEnd();
        // let temp = [];
        // lastlocation.forEach((i) => temp.push({
        // 'GPS Current Location' : await this.
        // 'lorry_no' : i['lorry_no'].trim(),
        // 'lat' : parseFloat(i['GPSLatitude'].trim()),
        // 'long': parseFloat(i['GPSLongitude'].trim())}));
        // let a = temp.map(i => this.getReverseGeoCode(a['lat'],a['long']));
        // console.log(a);
        // console.log(temp);

        var lastlocationF = [];
        if (Array.isArray(lastlocation)) {
          if (lastlocation.length > 0) {

            lastlocation.forEach(async (ll) => {

              
              lastlocationF.push({
                'Status': !ll['Trip Status'] ? '' : (ll['Trip Status'].trim() == 'In Collection') ? 'In Col' : (ll['Trip Status'].trim() == 'In Delivery') ? 'In Del' : '',
                'Vehicle': !ll['lorry_no'] ? '' : (ll['lorry_no'].trim() + ' (' + (!ll['vehiclecode'] ? '' : ll['vehiclecode'].trim()) + ')'),
                'GPS Log Time': !ll['GPSLogTime'] ? '' : this.formatDatetoString(ll['GPSLogTime'].trim()),
                'Last Job Update Time' : !ll['DateTimeLog'] ? '' : this.formatDatetoString(ll['DateTimeLog'].trim()),

                'No Job Since' : (!ll['MinutesLagFrLastUpdate'] ? '' : this.formatMinutesToHoursMin(ll['MinutesLagFrLastUpdate']).trim()),

                'GPS Current Location': (!ll['GPSLocName'] ? '' : ll['GPSLocName'].trim()) + (' (' + (!ll['GPSLatitude'] ? '' : ll['GPSLatitude'].trim()) + ',' + (!ll['GPSLongitude'] ? '' : ll['GPSLongitude'].trim()) + ')'),


                'Driver': !ll['Drivername'] ? '' : (ll['Drivername'].trim() + ' (' + (!ll['DriverCode'] ? '' : ll['DriverCode'].trim()) + ')' + 
                ( (!ll['Staff_Status']) ? '' : 
                ( (ll['Staff_Status'].trim() == 'O')
                 ? '\t<img src="https://img.icons8.com/fluency-systems-regular/16/fa314a/attendance-mark--v19.png"/>' 
                 : '\t<img src="https://img.icons8.com/fluency-systems-regular/16/26e07f/attendance-mark--v19.png"/>'))), 


                //  Attendance icon by Icons8</a>


                'Pending Trips': !ll['PendingTrips'] ? '0' : ll['PendingTrips'],
                'Consignment #': !ll['ConsignmentNo'] ? '' : ll['ConsignmentNo'].trim(),
                'ETA': !ll['ETA'] ? '' : this.formatDatetoString(ll['ETA'].trim()),
                'From': (!ll['DepCompany'] ? '' : ll['DepCompany'].trim()) + ((!ll['DepLat'] || !ll['DepLon']) ? '' : (' (' + (!ll['DepLat'] ? '0' : ll['DepLat'].trim()) + ',' + (!ll['DepLon'] ? '0' : ll['DepLon'].trim()) + ')')),
                'To': (!ll['DestCompany'] ? '' : ll['DestCompany'].trim()) + ((!ll['DestLat'] || !ll['DestLon']) ? '' : (' (' + (!ll['DestLat'] ? '0' : ll['DestLat'].trim()) + ',' + (!ll['DestLon'] ? '0' : ll['DestLon'].trim()) + ')')),

                'Latitude': !ll['GPSLatitude'] ? '' : ll['GPSLatitude'].trim(), 
                'Longitude': !ll['GPSLongitude'] ? '' : ll['GPSLongitude'].trim(),
                'Dep Code': !ll['DepartureCode'] ? '' : ll['DepartureCode'].trim(),
                'Dep Latitude': !ll['DepLat'] ? '' : ll['DepLat'].trim(),
                'Dep Longitude': !ll['DepLon'] ? '' : ll['DepLon'].trim(),
                'Dep Company': !ll['DepCompany'] ? '' : ll['DepCompany'].trim(),
                'Dep Company Code': !ll['DepartureCode'] ? '' : ll['DepartureCode'].trim(),
                'Dest Code': !ll['DestinationCode'] ? '' : ll['DestinationCode'].trim(),
                'Dest Latitude': !ll['DestLat'] ? '' : ll['DestLat'].trim(),
                'Dest Longitude': !ll['DestLon'] ? '' : ll['DestLon'].trim(),
                'Dest Company': !ll['DestCompany'] ? '' : ll['DestCompany'].trim(),
                'Dest Company Code': !ll['DestinationCode'] ? '' : ll['DestinationCode'].trim(),
                'Driver Name': !ll['Drivername'] ? '' : ll['Drivername'].trim(),
                'Driver Code': !ll['DriverCode'] ? '' : ll['DriverCode'].trim(),
                'Job No': !ll['ConsignmentNo'] ? '' : ll['ConsignmentNo'].trim(),
                'Staff_Status': ll['Staff_Status'] || ''
              });
            });
            //lastlocationF['Driver'] += "<p src:'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png'></p>"

            this.vtHideColumns.push('Staff_Status')
            // console.log(lastlocationF);
            this.$set(this.vtPersistentData, 'lastlocation', lastlocationF);
          } else { this.$set(this.vtPersistentData, 'lastlocation', [{ 'Status' : 'No Data' }]); }
        } else { this.$set(this.vtPersistentData, 'lastlocation', [{ 'Status' : 'No Data', 'Error' : lastlocation }]); }
      } catch (e) { /*console.log(e);*/ this.$set(this.vtPersistentData, 'lastlocation', [{ 'Status' : 'No Data' }]); }
      // this.loading = false;
      this.vtLoaderText = '';
      this.getVehicleMarkers();
      this.vtVehicleData = this.vtPersistentData['lastlocation'];
    },
    getMenuItems: async function () {
      try {
        var menuItem = await this.$apiCallV2(`/VehicleTracker/GetListMaster?master=HMS_RC_JOBBUCKETS`);
        //console.log(menuItem['data']);
        if (Array.isArray(menuItem)) {
          menuItem.forEach((m) => {
            this.vtMenuData.push({
              'title': !m['Description'] ? '' : m['Description'],
              'pageTitle': !m['Description'] ? '' : (m['Description'].replace(/ /g, '').replace(/\-/g, '') + 'Page'),
              'icon': 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/' + (!m['Description'] ? '' : (m['Description'].replace(/ /g, '').replace(/\-/g, '') + '_gray')) + '.png',
              //'show': (m['Description'] == 'Pending Collection') ? true : false,
              'show': false,
              'showPopup': false,
              'showLoad': false,
              'showError': false,
              'errorMsg': 'No Information',
              'data': [{ 'Status': 'No Data' }],
              'additionalCol' : [{ value: 'Assign', type: 'button', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-in-transit-64.png', index: 0 }],
              'selectedRow': {},
            });
            // console.log('https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/' + (!m['Description'] ? '' : (m['Description'].replace(/ /g, '').replace(/\-/g, '') + '_red')) + '.png');
          });
        }
      } catch (e) { console.log(e); }
      
    },
    getPendingTrip: async function (driver) {
      this.loading = true; this.loadText = 'Getting Pending Trips';
      try {
        var pendingtrip = await this.$apiCallV2(`/VehicleTracker/GetHMSTripsByDriver?driver=` + driver);
        //console.log(pendingtrip);
        if (Array.isArray(pendingtrip)) {
          pendingtrip.forEach((pt) => {
            this.vtPTData.push({
              'ContainerNo': !pt['ContainerNo'] ? '' : pt['ContainerNo'].trim(),
              'ContSize': !pt['ContSize'] ? '' : pt['ContSize'].trim(),
              'ContType': !pt['ContType'] ? '' : pt['ContType'].trim(),
              'B2BContainerNo': !pt['B2BContainerNo'] ? '' : pt['B2BContainerNo'].trim(),
              'B2BContSize': !pt['B2BContSize'] ? '' : pt['B2BContSize'].trim(),
              'B2BContType': !pt['B2BContType'] ? '' : pt['B2BContType'].trim(),
              'ConsignmentNo': !pt['ConsignmentNo'] ? '' : pt['ConsignmentNo'].trim(),
              'B2BConsignmentNo': !pt['B2BConsignmentNo'] ? '' : pt['B2BConsignmentNo'].trim(),
              'MovementType': !pt['MovementType'] ? '' : pt['MovementType'].trim(),
              'BillToName': !pt['BillToName'] ? '' : pt['BillToName'].trim(),
              'FromArea': !pt['FromArea'] ? '' : pt['FromArea'].trim(),
              'ToArea': !pt['ToArea'] ? '' : pt['ToArea'].trim(),
            });
          });
        } //console.log(this.vtPTData);
      } catch (e) { console.log(e); }

      this.loading = false;
      this.vtPTShow = true;
    },
    getRFCContainers: async function () {
      var mRFCMarker = this.mMarker.filter((m) => { return m['mName'] == 'rfc'; });
      var menuItem = this.vtMapMenuData.filter((m) => { return m['title'] == 'Show RFC Containers'; })[0];

      if (mRFCMarker.length <= 0) {
        this.loading = true; this.loadText = 'Getting RFC Containers';
        try {
          var rfccontainer = await this.$apiCallV2(`/VehicleTracker/GetHMSRadiocallCollection`);
          // console.log(rfccontainer[0]);
          var rfccontainerF = [];
          //console.log(rfccontainer['data'].length + ' | ' + rfccontainerF.length);
          if (Array.isArray(rfccontainer)) {
            menuItem['icon'] = 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RFC_green.png';
            var rfccontainerFF = rfccontainer.filter((rfc) => { return rfc['Latitude'] && rfc['Longtitude'] && (rfc['Latitude'] != 0 || rfc['Longtitude'] != 0); });
            // console.log(rfccontainerFF);
            rfccontainerFF.forEach((rfc) => {
              rfccontainerF.push({
                'ConsignmentNo': !rfc['ConsignmentNo'] ? '' : rfc['ConsignmentNo'].trim(),
                'ContainerNo': !rfc['ContainerNo'] ? '' : rfc['ContainerNo'].trim(),
                'Company': !rfc['company'] ? '' : rfc['company'].trim(),
                'Area': !rfc['AreaName'] ? '' : rfc['AreaName'].trim(),
                'Delivery Time': !rfc['AreaName'] ? '' : this.formatDatetoString(rfc['DelDate'].trim()),
                'ETA': !rfc['AreaName'] ? '' : this.formatDatetoString(rfc['Date_ETA'].trim()),
                'Advice For RFC': !rfc['RecRFCDate'] ? '' : this.formatDatetoString(rfc['RecRFCDate'].trim()),
                'To Collect': !rfc['RFCDate'] ? '' : this.formatDatetoString(rfc['RFCDate'].trim()),
                'Drop Off': !rfc['DropOff'] ? '' : rfc['DropOff'].trim(),
                'Latitude': !rfc['Latitude'] ? '' : rfc['Latitude'].trim(),
                'Longitude': !rfc['Longtitude'] ? '' : rfc['Longtitude'].trim(),
                'RFC Remarks': !rfc['RFCRemarks'] ? '' : rfc['RFCRemarks'].trim(),
                'Remarks': !rfc['Remarks'] ? '' : rfc['Remarks'].trim(),
                'Cont Size': !rfc['ContSize'] ? '' : rfc['ContSize'].toString().trim(),
                'Cont Type': !rfc['ContType'] ? '' : rfc['ContType'].trim(),
                'Handling Type': !rfc['HandlingType'] ? '' : rfc['HandlingType'].trim(),
                'Delivery Type': !rfc['DeliveryType'] ? '' : rfc['DeliveryType'].trim(),
                'Seal No': !rfc['SealNo'] ? '' : rfc['SealNo'].trim(),
                'Delivery Trailer': !rfc['DeliveryTrailer'] ? '' : rfc['DeliveryTrailer'].trim(),
                'Departure Code': !rfc['DepartureCode'] ? '' : rfc['DepartureCode'].trim(),
                'Destination Code': !rfc['DestinationCode'] ? '' : rfc['DestinationCode'].trim(),
              });
              //console.log(rfc['RFCRemarks']);
            });
          } else { console.log(rfccontainer); }
          //console.log(rfccontainerF);
          this.$set(this.vtPersistentData, 'rfccontainer', rfccontainerF);
          this.$set(this.vtPersistentData, 'rfccontainerRaw', rfccontainerFF);
        } catch (e) { console.log(e); }

        this.loading = false;
        this.getRFCMarkers();
      } else {
        //console.log('RFC already retrieved');
        this.rfcShowPopUp = false;
        this.rfcSelectedC = {};
        menuItem['icon'] = 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RFC_gray.png';
        mRFCMarker.forEach((m) => {
          var mIndex = this.mMarker.indexOf(m);
          this.mMarker.splice(mIndex, 1);
        });
      }

    },
    getAssignData: async function () {
      //-------- Prime Mover
      try {
        var assignPM = await this.$apiCallV2(`/VehicleTracker/GetVehicleListByCategory?vehcat=PM&available=1`);
        // console.log(assignPM[0]);
        if (Array.isArray(assignPM)) {
          assignPM.forEach((pm) => {
            this.rfcPM.push({
              'type' : 'PM',
              'VehicleNo': !pm['VehicleNo'] ? '' : pm['VehicleNo'].trim(),
              'VehicleCode': !pm['VehicleCode'] ? '' : pm['VehicleCode'].trim(),
              'Availability': !pm['Availability'] ? '' : pm['Availability'].trim(),
              'RoadTaxExpiryDate': !pm['RoadTaxExpiryDate'] ? '' : this.formatDatetoString(pm['RoadTaxExpiryDate'].trim()),
              'InspectionDate': !pm['InspectionDate'] ? '' : this.formatDatetoString(pm['InspectionDate'].trim()),
              'PermitExpiryDate': !pm['PermitExpiryDate'] ? '' : this.formatDatetoString(pm['PermitExpiryDate'].trim()),
              'desc': !pm['VehicleNo'] ? '' : !pm['VehicleCode'] ? '' : (pm['VehicleNo'].trim() + ' - ' + pm['VehicleCode'].trim())
            });
          });
        }
        this.$set(this.vtPersistentData, 'assignPM', assignPM);
      } catch (e) { console.log(e); }

      //-------- Driver
      try {
        var assignDriver = await this.$apiCallV2(`/VehicleTracker/GetEmployeeListByDepartment`);
        //console.log(assignDriver['data']);
        if (Array.isArray(assignDriver)) {
          assignDriver.forEach((d) => {
            this.rfcDriver.push({
              'type' : 'D',
              'Staff_No': !d['Staff_No'] ? '' : d['Staff_No'].trim(),
              'Staff_Name': !d['Staff_Name'] ? '' : d['Staff_Name'].trim(),
              'DrvLicenseExpiryDate': !d['DrvLicenseExpiryDate'] ? '' : this.formatDatetoString(d['DrvLicenseExpiryDate'].trim()),
              'BadgeLicenseExpiryDate': !d['BadgeLicenseExpiryDate'] ? '' : this.formatDatetoString(d['BadgeLicenseExpiryDate'].trim()),
              'PortPassExpiryDate': !d['PortPassExpiryDate'] ? '' : this.formatDatetoString(d['PortPassExpiryDate'].trim()),
              'desc': !d['Staff_No'] ? '' : !d['Staff_Name'] ? '' : (d['Staff_No'].trim() + ' - ' + d['Staff_Name'].trim()),
            });
          });
        }
        this.$set(this.vtPersistentData, 'assignDriver', assignDriver);
        var test = this.rfcDriver.filter((d) => { return d['DrvLicenseExpiryDate']; });
      } catch (e) { console.log(e); }

      // //-------- Movement
      // try {
      //   var assignMovement = await this.$apiCallV2(`/VehicleTracker/GetMovementType?delcol=c`);
      //   //console.log(assignMovement['data']);
      //   if (Array.isArray(assignMovement['data'])) {
      //     assignMovement['data'].forEach((m) => {
      //       this.rfcMovement.push({
      //         'type' : 'M',
      //         'MovementType': !m['MovementType'] ? '' : m['MovementType'].trim(),
      //         'MovementTypeDesc': !m['MovementTypeDesc'] ? '' : m['MovementTypeDesc'].trim(),
      //         'desc': !m['MovementType'] ? '' : !m['MovementTypeDesc'] ? '' : (m['MovementType'].trim() + ' - ' + m['MovementTypeDesc'].trim()),
      //       });
      //     });
      //   }
      //   this.$set(this.vtPersistentData, 'assignMovement', assignMovement['data']);
      //   this.rfcMovementSelected = this.rfcMovement.filter((am) => { return am['MovementType'] == 'C1W' })[0];
      // } catch (e) { console.log(e); }

      //-------- From / To
      try {
        var assignFromTo = await this.$apiCallV2(`/VehicleTracker/GetListMaster?master=destination&module=FMS`);
        //console.log(assignFromTo);
        var assignFromToF = [];
        if (Array.isArray(assignFromTo)) {
          assignFromTo.forEach((ft) => {
            assignFromToF.push({
              'type': 'FT',
              'Dest Code': !ft['Destination Code'] ? '' : ft['Destination Code'].trim(),
              'Area Code': !ft['Area Code'] ? '' : ft['Area Code'].trim(),
              'Area Name': !ft['Area Name'] ? '' : ft['Area Name'].trim(),
              'Address': !ft['Address'] ? '' : ft['Address'].trim(),
              'Post Code': !ft['PostCode'] ? '' : ft['PostCode'].trim(),
              'City': !ft['City'] ? '' : ft['City'].trim(),
              'Company': !ft['Company'] ? '' : ft['Company'].trim(),
              'Latitude': !ft['Latitude'] ? '' : ft['Latitude'].trim(),
              'Longitude': !ft['Longitude'] ? '' : ft['Longitude'].trim(),
              'desc': !ft['Destination Code'] ? '' : ft['Destination Code'].trim() + (!ft['City'] ? '' : ' - ' + ft['City'].trim()),
            });
          });
        }
        this.$set(this.vtPersistentData, 'assignFromTo', assignFromToF);
        this.$set(this.vtPersistentData, 'assignFromToRaw', assignFromTo);
      } catch (e) { console.log(e); }



    },
    getVehicleMarkers: function () {
      try {
        this.vtPersistentData['lastlocation'].forEach((ll) => {
          this.mMarker.push({
            mName: 'lorry',
            position: { lat: parseFloat(ll['Latitude']), lng: parseFloat(ll['Longitude']) },
            label: { text: ll['Vehicle'], color: '#F24A01', fontSize: '12px', fontWeight: 'bold', },
            opacity: 1,
            icon: {
              url: ((ll["Status"] == 'In Col' || ll["Status"] == 'In Del') ? 'https://dsmapi.logistics.systems/dsm6gicons/TruckOn.png' : 'https://dsmapi.logistics.systems/dsm6gicons/TruckOff.png'),
              scaledSize: { width: 30, height: 30 },
              labelOrigin: new google.maps.Point(15, -10),
            },
            info: [
              { type: 'string', title: 'Vehicle', value: !ll['Vehicle'] ? '' : ll['Vehicle'] },
              // { type: 'string', title: 'Vehicle Code', value: !ll['Vehicle Code'] ? '' : ll['Vehicle Code'] },
              { type: 'string', title: 'Driver', value: !ll['Driver Name'] ? '' : ll['Driver Name'] + ' (' + ((!ll['Driver Code'] ? '' : ll['Driver Code']) + ')')},
              // { type: 'string', title: 'Driver Code', value: !ll['Driver Code'] ? '' : ll['Driver Code'] },
              { type: 'string', title: 'Container #', value: !ll['Job No'] ? '' : ll['Job No'] },
              { type: 'string', title: 'From', value: !ll['Dep Company'] ? '' : ll['Dep Company']+ ' (' + ((!ll['Dep Company Code'] ? '' : ll['Dep Company Code']) + ')')},
              { type: 'string', title: 'To', value: !ll['Dest Company'] ? '' : ll['Dest Company']+ ' (' + ((!ll['Dest Company Code'] ? '' : ll['Dest Company Code']) + ')')},
              { type: 'string', title: 'Last Job Update', value : !ll['Last Job Update Time'] ? '' : ll['Last Job Update Time']},
              { type: 'string', title: 'No Job Since', value : !ll['No Job Since'] ? '' : ll['No Job Since']},
            ]
          })
        });
      } catch (e) { /*console.log(e);*/ }
      
    },
    getRFCMarkers: function () {
      var rfcMarkers = this.mMarker.filter((m) => { return m['mName'] == 'rfc' });
      // console.log(rfcMarkers[0]);
      rfcMarkers.forEach((m) => {
        var rfcIndex = this.mMarker.indexOf(m);
        this.mMarker.splice(rfcIndex, 1);
      });
      try {
        this.vtPersistentData['rfccontainer'].forEach((rfc) => {
          if (parseFloat(rfc['Latitude']) <= 0 || parseFloat(rfc['Longitude']) <= 0) { console.log('Null Coord Found'); }
          this.mMarker.push({
            mName: 'rfc',
            position: { lat: parseFloat(rfc['Latitude']), lng: parseFloat(rfc['Longitude']) },
            label: { text: '', color: '#00000000', fontSize: '0px', fontWeight: 'bold', },
            icon: {
              url: 'https://dsmapi.logistics.systems/dsm6gicons/Warehouse.png',
              scaledSize: { width: 30, height: 30 },
              labelOrigin: new google.maps.Point(15, -10),
            },
            info: [
              { type: 'string', title: 'CN / Cont. No', value: (!rfc['ConsignmentNo'] ? '' : rfc['ConsignmentNo']) + ' / ' + (!rfc['ContainerNo'] ? '' : rfc['ContainerNo']) },
              { type: 'string', title: 'SzTyp / Hdg / Del', value: (!rfc['Cont Size'] ? '' : rfc['Cont Size'] + (!rfc['Cont Type'] ? '' : rfc['Cont Type'])) + ' / ' + (!rfc['Handling Type'] ? '' : rfc['Handling Type']) + ' / ' + (!rfc['Delivery Type'] ? '' : rfc['Delivery Type']) },
              { type: 'string', title: 'Company', value: (!rfc['Company'] ? '' : rfc['Company']) + ' [' + (!rfc['Area'] ? '' : rfc['Area']) + ']'},
              { type: 'string', title: 'Delivery Time', value: !rfc['Delivery Time'] ? '' : rfc['Delivery Time'] },
              { type: 'string', title: 'ETA', value: !rfc['ETA'] ? '' : rfc['ETA'] },
              { type: 'string', title: 'Advice For RFC', value: !rfc['Advice For RFC'] ? '' : rfc['Advice For RFC'] },
              { type: 'string', title: 'To Collect', value: (!rfc['To Collect'] ? '' : rfc['To Collect'] + (!rfc['RFC Remarks'] ? '' : (' ' + rfc['RFC Remarks']))) , css: 'color: #f00'},
              { type: 'string', title: 'Drop Off', value: !rfc['Drop Off'] ? '' : rfc['Drop Off'] },
              { type: 'button', title: 'Assign Collection' },
              { type: '', title: 'ConsignmentNo', value: !rfc['ConsignmentNo'] ? '' : rfc['ConsignmentNo'] },
              { type: '', title: 'ContainerNo', value: !rfc['ContainerNo'] ? '' : rfc['ContainerNo'] },
              { type: '', title: 'Company', value: !rfc['Company'] ? '' : rfc['Company'] },
              { type: '', title: 'Area', value: !rfc['Area'] ? '' : rfc['Area'] },
            ]
          })
        });
      } catch (e) { /*console.log(e);*/ }
    },
    clearPTData: function () {
      this.vtPTShow = false;
      this.vtPTData = [];
      this.vtPTSelected = {};
    },  
    getRefreshItems: function () {
      try {
        var dropdown = this.$refs['vtRefreshDropdown'];
        this.mRefreshTiming.forEach((r) => {
          var optionItem = document.createElement('option');
          optionItem['value'] = r['ms'];
          optionItem['innerHTML'] = r['desc'];
          optionItem['selected'] = (r['desc'] == this.mDefaultRefresh['desc']) ? true : false;
          dropdown.appendChild(optionItem);
        })
      } catch (e) { console.log(e); }
    },
    refreshData: function () {
      try {
        var dropdown = this.$refs['vtRefreshDropdown'];
        clearInterval(this.mRefreshInterval);
        this.mRefreshInterval = setInterval(() => { this.refreshData(); }, dropdown['value']);
      } catch (e) { /*console.log(e);*/ }
      
      var rfcItem = this.vtMapMenuData.filter((m) => { return m['title'] == 'Show RFC Containers'; })[0];

      this.rfcShowPopUp = false;
      this.rfcSelectedC = {};
      this.rfcPMSelected = null;
      this.rfcDriverSelected = null;
      this.rfcMovementSelected = this.rfcMovement.filter((am) => { return am['MovementType'] == 'C1W' })[0];
      this.rfcETD = new Date; this.rfcETA = new Date;
      this.rfcMsg['msg'] = ''; this.rfcMsg['color'] = '';
      rfcItem['icon'] = 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/RFC_gray.png';
      this.mCenter = defaultpos;
      this.mZoom = defaultzoom;
      this.clearPTData();
      this.vtVehicleData = [{ 'Status' : 'No Data' }];
      this.mMarker = [];
      this.getLastLocation();
    },
    //-------- RFC Methods
    rfcAssign: function (rfc) {
      switch (rfc['type']) {
        case 'PM':
          this.rfcErrors['errorPM'] = '';
          var pmDetail = this.vtVehicleData.filter((v) => { return v['Vehicle Code'].trim() == rfc['VehicleCode']; })[0];
          if (pmDetail['Driver Code']) {
            var driverDetail = this.rfcDriver.filter((d) => { return d['Staff_No'] == pmDetail['Driver Code'].trim() })[0];
            this.rfcDriverSelected = driverDetail;
            this.rfcErrors['errorDriver'] = '';
            //console.log(pmDetail['Driver Code']);
            //console.log(driverDetail);
          }
          break;
        case 'D':
          this.rfcErrors['errorDriver'] = '';
          break;
        case 'M':
          this.rfcErrors['errorMovement'] = '';
          break;
        case 'FT':
          
          break;
      }
    },

    //-------- Tabulator Methods
    cellBtnVehicle: function (btn, row) {
      switch (btn) {
        case 'Show Pending Trips':
          this.vtPTSelected = row;
          console.log(this.vtPTSelected);
          this.getPendingTrip(row['Driver Code'])
          break;
        case 'Show Route':
          this.routeView = true;
          var rowI = this.vtVehicleData.indexOf(row);
          console.log(rowI);
          var curI = this.vtVehicleData.indexOf(this.mDirCurrent);
          console.log(curI);

          if (row && (rowI != curI)) {
            this.mDirCurrent = row;
            this.mCenter = { lat: parseFloat(row['Latitude']), lng: parseFloat(row['Longitude']) }; this.mZoom = 18;
            if (row['Trip Status']) {
              var route = {};
              this.$set(route, 'fromlat', !row['Dep Latitude'] ? 0 : parseFloat(row['Dep Latitude']));
              this.$set(route, 'fromlng', !row['Dep Longitude'] ? 0 : parseFloat(row['Dep Longitude']));
              this.$set(route, 'tolat', !row['Dest Latitude'] ? 0 : parseFloat(row['Dest Latitude']));
              this.$set(route, 'tolng', !row['Dest Longitude'] ? 0 : parseFloat(row['Dest Longitude']));
              this.mDirections = route;
            }

            var mLMarker = this.mMarker.filter((m) => { return m['mName'] == 'lorry'; });
            mLMarker.forEach((m) => { m['opacity'] = (m['info'][0]['value'] == row['Vehicle']) ? 1 : 0.2 });

          } else { this.mResetView(); }
          break;
      } 
    },
    rowSelectVehicle: function (row) {

    },

    //-------- Map Methods
    mResetView: function () {
      this.mCenter = defaultpos;
      this.mZoom = defaultzoom;
      this.mDirections = { fromlat: 0, fromlng: 0, tolat: 0, tolng: 0 };
      this.mDirCurrent = {};
      this.routeView = false;

      var mLMarker = this.mMarker.filter((m) => { return m['mName'] == 'lorry'; });
      mLMarker.forEach((m) => { m['opacity'] = 1; });
    },
    vtMapBtn: async function (title, marker) {
      switch (title) {
        case 'Assign Collection':
          //console.log(title);
          //console.log(marker);
          // try {
          //   var assignMovement = await this.$apiCallV2(`/VehicleTracker/GetMovementType?cnno=` + this.rfcSelectedC['ConsignmentNo']);
          //   //console.log(assignMovement['data']);
          //   if (Array.isArray(assignMovement['data'])) {
          //     assignMovement['data'].forEach((m) => {
          //       this.rfcMovement.push({
          //         'type' : 'M',
          //         'MovementType': !m['MovementType'] ? '' : m['MovementType'].trim(),
          //         'MovementTypeDesc': !m['MovementTypeDesc'] ? '' : m['MovementTypeDesc'].trim(),
          //         'desc': !m['MovementType'] ? '' : !m['MovementTypeDesc'] ? '' : (m['MovementType'].trim() + ' - ' + m['MovementTypeDesc'].trim()),
          //       });
          //     });
          //   }
          //   this.$set(this.vtPersistentData, 'assignMovement', assignMovement['data']);
          //   this.rfcMovementSelected = this.rfcMovement.filter((am) => { return am['MovementType'] == 'C1W' })[0];
          // } catch (e) { console.log(e); }

          // this.rfcSelectedC = this.vtPersistentData['rfccontainer'].filter((r) => { return r['ConsignmentNo'] == markerConNo; })[0];
          // console.log(this.rfcSelectedC);
          // this.rfcSealNo = this.rfcSelectedC['Seal No'];
          // this.rfcTrailerNo = this.rfcSelectedC['Delivery Trailer'];
          // var rfcFrom = this.vtPersistentData['assignFromTo'].filter((ft) => { return ft['Dest Code'] == this.rfcSelectedC['Departure Code']; });
          // if (rfcFrom.length > 0) { this.rfcFromSelected = rfcFrom[0] }
          // var rfcTo = this.vtPersistentData['assignFromTo'].filter((ft) => { return ft['Dest Code'] == this.rfcSelectedC['Destination Code']; });
          // if (rfcTo.length > 0) { this.rfcToSelected = rfcTo[0] }
          // this.rfcRemarks = this.rfcSelectedC['Remarks'];
          // this.rfcShowPopUp = true;

          var markerConNo = marker['info'].filter((m) => { return m['title'] == 'ConsignmentNo'; })[0]['value']
          this.assignSelected = this.vtPersistentData['rfccontainer'].filter((r) => { return r['ConsignmentNo'] == markerConNo; })[0];
          this.assignSelectedRaw = this.vtPersistentData['rfccontainerRaw'].filter((rfc) => { return rfc['ContainerNo'].trim() == this.assignSelected['ContainerNo'] })[0];
          //console.log(this.assignSelected);
          this.assignTitle = 'Assign Collection';
          this.assignShow = true;

          break;
        case 'Close':
          this.rfcShowPopUp = false;
          this.rfcSelectedC = {};
          this.rfcPMSelected = null;
          this.rfcDriverSelected = null;
          this.rfcMovementSelected = this.rfcMovement.filter((am) => { return am['MovementType'] == 'C1W' })[0];
      this.rfcETD = new Date; this.rfcETA = new Date;
          this.rfcMsg['msg'] = ''; this.rfcMsg['color'] = '';
          break;
        case 'Save':
          this.rfcErrors['errorPM'] = this.rfcPMSelected ? '' : 'Prime Mover is required';
          this.rfcErrors['errorDriver'] = this.rfcDriverSelected ? '' : 'Driver is required';
          this.rfcErrors['errorMovement'] = this.rfcMovementSelected ? '' : 'Movement is required';
          var errorF = false;
          Object.keys(this.rfcErrors).forEach((e) => { if (this.rfcErrors[e]) { errorF = true; } })
          if (errorF) {
            this.rfcMsg['msg'] = 'Please fill the required fields'; this.rfcMsg['color'] = 'rgba(255, 121, 121, 0.37)';
          } else {
            this.rfcMsg['msg'] = ''; this.rfcMsg['color'] = '';

            
            var assignRaw = this.vtPersistentData['rfccontainerRaw'].filter((rfc) => { return rfc['ContainerNo'].trim() == this.rfcSelectedC['ContainerNo'] });
            var assignData = {
              'VehicleCode': !this.rfcPMSelected['VehicleCode'] ? '' : this.rfcPMSelected['VehicleCode'].trim(),
              'Staff_No': !this.rfcDriverSelected['Staff_No'] ? '' : this.rfcDriverSelected['Staff_No'].trim(),
              'MovementType': !this.rfcMovementSelected['MovementType'] ? '' : this.rfcMovementSelected['MovementType'].trim(),
              'JIDate': !this.rfcETD ? '' : this.formatDatetoString(this.rfcETD).split(' ')[0],
              'CN': !this.rfcSelectedC['ConsignmentNo'] ? '' : this.rfcSelectedC['ConsignmentNo'].trim(),
              'B2BCN': !assignRaw['B2BConsignmentNo'] ? '' : assignRaw['B2BConsignmentNo'].trim(),
              'SealNo': !this.rfcSealNo ? '' : this.rfcSealNo.trim(),
              'DepartureCode': !this.rfcFromSelected ? '' : this.rfcFromSelected['Dest Code'].trim(),
              'DestinationCode': !this.rfcToSelected ? '' : this.rfcToSelected['Dest Code'].trim(),
              'EstDepartTime': !this.rfcETD ? '' : this.formatDatetoString(this.rfcETD) + ':00',
              'EstArriveTime': !this.rfcETA ? '' : this.formatDatetoString(this.rfcETA) + ':00',
              'TrCode': !this.rfcTrailerNo ? '' : this.rfcTrailerNo.trim(),
              'Remarks': !this.rfcRemarks ? '' : this.rfcRemarks.trim(),
              'UserID': !assignRaw['UserID'] ? '' : assignRaw['UserID'].trim(),
              'DateUpdated': !assignRaw['DateUpdated'] ? '' : assignRaw['DateUpdated'].trim(),
              'DeviceID': '',
              'MobileNo': '',
              'GPSLatitude': !this.rfcSelectedC['Latitude'] ? '' : this.rfcSelectedC['Latitude'].trim(),
              'GPSLongitude': !this.rfcSelectedC['Longitude'] ? '' : this.rfcSelectedC['Longitude'].trim(),
            };

            // console.log(assignData);
            
            var assignR = await this.$apiCallV2(`/VehicleTracker/HMSAssignTrip`, assignData);
            console.log(assignR);
            if (Array.isArray(assignR)) {
              if (assignR[0]['Results'] > 0) {
                this.rfcMsg['msg'] = assignR[0]['ErrMsg']; this.rfcMsg['color'] = 'rgba(255, 121, 121, 0.37)';
              } else {
                this.rfcMsg['msg'] = 'Detail successful'; this.rfcMsg['color'] = 'rgba(126, 255, 121, 0.37)';
              }
            } else { this.rfcMsg['msg'] = assignR; this.rfcMsg['color'] = 'rgba(255, 121, 121, 0.37)'; }
          }
          break;
      }
    },
    
    //-------- Menu Methods
    vtMapMenuClicked: function (menu) {
      switch (menu['title']) {
        case 'Legend':
          this.mLegendShow = !this.mLegendShow;
          break;
        case 'Refresh':
          this.refreshData();
          break;
        case 'Show RFC Containers':
          this.getRFCContainers();
          break;
        case 'Refresh Interval':
          this.mRefreshShow = !this.mRefreshShow;
          break;
      }
    },
    vtMultiMenuClicked: function (menu) {
      var menuIndex = this.vtMenuData.indexOf(menu);
      this.vtMenuData[menuIndex]['show'] = !this.vtMenuData[menuIndex]['show'];
      this.vtMenuData[menuIndex]['icon'] = 'https://dsmapi.logistics.systems/dsm6gicons/VehicleTracker/' + (!this.vtMenuData[menuIndex]['title'] ? '' : (this.vtMenuData[menuIndex]['title'].replace(/ /g, '').replace(/\-/g, '') + '_')) + (this.vtMenuData[menuIndex]['show'] ? 'green' : 'gray') + '.png'
      this.vtMGetData(this.vtMenuData[menuIndex]['title']);
      this.vtMenuData[menuIndex]['showPopup'] = false;
      this.vtMenuData[menuIndex]['showError'] = false;
      this.vtMenuData[menuIndex]['errorMsg'] = 'No Information';
      //console.log(this.vtMenuData[menuIndex]['icon']);
    },

    //-------- MultiTable PopUp Methods
    vtMBtn: function (action, title) {
      switch (action) {
        case 'close':
          var menuItem = this.vtMenuData.filter((m) => { return (m['title'] == title); })[0];
          this.$set(menuItem, 'showPopup', false);
          this.$set(menuItem, 'selectedRow', {});
          //console.log(menuItem);
          break;
      }
    },
    vtMGetData: async function (table) {
      
      var menuItem = this.vtMenuData.filter((m) => { return m['title'] == table; })[0];
      // if (menuItem['show']) {
      //   menuItem['showLoad'] = true;
      //   try {
      //     var menuData = await this.$apiCallV2(`/VehicleTracker/GetHMSJobListing?bucket=` + table);
      //     let columnsOrder = Object.keys(menuData[0]);

      //     console.log(columnsOrder); 

      //     if (Array.isArray(menuData)) {
      //       menuItem['data'] = [];
      //       if (menuData.length > 0) {
      //         console.log(menuData.length);
      //         menuData.forEach((m) => {
      //           // console.log(m);
      //           // menuItem['data'].push(m);
      //           menuItem['data'].push(
      //             {
      //               '#': m['#'],
      //               'Container #' : !m['Container #'] ? '' : m['Container #'].trim(),
      //               'Consignment #' : !m['Consignment #'] ? '' : m['Consignment #'].trim(),
      //               'Sz/Ty' : !m['Sz/Ty'] ? '' : m['Sz/Ty'].trim(),
      //               'Send To' : !m['Send To'] ? '' : m['Send To'].trim(),
      //               'Send To Area' : !m['Send To Area'] ? '' : m['Send To Area'].trim(),
      //               'Trailer' : !m['Trailer'] ? '' : m['Trailer'].trim(),
      //               'Delivery Date' : !m['Delivery Date'] ? '' : m['Delivery Date'].trim(),
      //               'RFC Time' : !m['RFC Time'] ? '' : m['RFC Time'].trim(),
      //               'Dropoff' : !m['Dropoff'] ? '' : m['Dropoff'].trim(),
      //               'Opening' : !m['Opening'] ? '' : m['Opening'].trim(),
      //               'Closing/Detention' : !m['Closing/Detention'] ? '' : m['Closing/Detention'].trim(),
      //               'Days' : m['Days'],
      //               'ContOp' : !m['ContOp'] ? '' : m['ContOp'].trim(),
      //               'Hdg' : !m['Hdg'] ? '' : m['Hdg'].trim(),
      //               'Del' : !m['Del'] ? '' : m['Del'].trim(),
      //               'RFC Remarks' : !m['RFC Remarks'] ? '' : m['RFC Remarks'].trim(),
      //               'Zone' : !m['Zone'] ? '' : m['Zone'].trim(),
      //               'Recd RFC Time' : !m['Recd RFC Time'] ? '' : m['Recd RFC Time'].trim(),
      //               'ETA Time' : !m['ETA Time'] ? '' : m['ETA Time'].trim(),
      //               'Booking Ref #' : !m['Booking Ref #'] ? '' : m['Booking Ref #'].trim(),
      //               'Customer' : !m['Customer'] ? '' : m['Customer'].trim(),
      //               'OfficeHrs' : !m['OfficeHrs'] ? '' : m['OfficeHrs'].trim(),
      //               'Plan PM' : !m['Plan PM'] ? '' : m['Plan PM'].trim(),
      //               'Plan Driver' : !m['Plan Driver'] ? '' : m['Plan Driver'].trim(),
      //             }
      //           );
                
      //           // var menuObj = {};
      //           // var menuCol = Object.keys(m).filter((c) => { return c.includes('Column'); })
      //           // menuCol.forEach((c) => { this.$set(menuObj, m[c], m[m[c]]); })
      //           // this.$set(menuObj, 'ConsignmentNo', !m['Consignment #'] ? '' : m['Consignment #'].trim());
      //           // this.$set(menuObj, 'ContainerNo', !m['Container #'] ? '' : m['Container #'].trim());
      //           // this.$set(menuObj, 'Cont Size', !m['Sz/Ty'] ? '' : m['Sz/Ty'].trim());
      //           // this.$set(menuObj, 'Handling Type', !m['Hdg'] ? '' : m['Hdg'].trim());
      //           // this.$set(menuObj, 'Delivery Type', !m['Del'] ? '' : m['Del'].trim());
      //           // menuItem['data'].push(menuObj);

      //           // menuItem['data'].push({
      //           //   'ConsignmentNo' : !m['Consignment #'] ? '' : m['Consignment #'].trim(),
      //           //   'ContainerNo' : !m['Container #'] ? '' : m['Container #'].trim(),
      //           //   'SzTyp / Hdg / Del' : !m['Sz/Ty'] ? '' : m['Sz/Ty'].trim() + (!m['Hdg'] ? '' : ' / ' + m['Hdg'].trim() + (!m['Del'] ? '' : ' / ' + m['Del'].trim())),
      //           //   'Pick Up' : !m['Pickup'] ? '' : m['Pickup'].trim(),
      //           //   'Send To' : !m['Send To'] ? '' : m['Send To'].trim(),
      //           //   'Send To Area' : !m['Send To Area'] ? '' : m['Send To Area'].trim(),
      //           //   'Required Date' : !m['Required Date'] ? '' : this.formatDatetoString(m['Required Date'].trim()),
      //           //   'Cont Size' : !m['Sz/Ty'] ? '' : m['Sz/Ty'].trim(),
      //           //   'Handling Type' : !m['Hdg'] ? '' : m['Hdg'].trim(),
      //           //   'Delivery Type' : !m['Del'] ? '' : m['Del'].trim(),
      //           // });
      //         });
      //       } else { menuItem['data'] = [{ 'Status': 'No Data' }]; }
      //     } else { menuItem['data'] = [{ 'Status': 'No Data', 'Error': menuData }]; menuItem['showError'] = true; menuItem['errorMsg'] = menuData; }
      //   } catch (e) { /*console.log(e);*/ menuItem['data'] = [{ 'Status' : 'No Data' }]; }
      //   menuItem['showLoad'] = false;
      // } else {
      //   menuItem['data'] = [{ 'Status' : 'No Data' }];
      // }

      if (menuItem['show']) {
        menuItem['showLoad'] = true;
        try {
          var menuData = await this.$apiCallV2(`/VehicleTracker/GetHMSJobListing?bucket=` + table);
          let keyNames = Object.keys(menuData[0]);

          keyNames.splice(2, 0, keyNames[18]);
          keyNames.splice(19, 1);
          console.log(menuData);
          console.log(keyNames);

          if (Array.isArray(menuData)){
            menuItem['data'] = []
            if(menuData.length > 0){
              for (let data of menuData){
                let tempObj = {}
                for (let key of keyNames){
                  tempObj[key] = data[key]
                }
                menuItem['data'].push(tempObj);
              }
      
          


            }else{ menuItem['data'] = [{'Status' : 'No Data'}]}
          }else{ 
            menuItem['data'] = [{'Status' : 'No Data', 'Error' : 'menuData'}];
            menuItem['showError'] = true;
            menuItem['errorMessage'] = menuData;
          }
        
        
          // if (Array.isArray(menuData)) {
          //   menuItem['data'] = [];
          //   if (menuData.length > 0) {
          //     console.log(menuData.length);
          //     menuData.forEach((m) => {
               
          //     });
          //   } else { menuItem['data'] = [{ 'Status': 'No Data' }]; }
          // } else { menuItem['data'] = [{ 'Status': 'No Data', 'Error': menuData }]; menuItem['showError'] = true; menuItem['errorMsg'] = menuData; }
        } catch (e) { /*console.log(e);*/ menuItem['data'] = [{ 'Status' : 'No Data' }]; }
        menuItem['showLoad'] = false;
      } else {
        menuItem['data'] = [{ 'Status' : 'No Data' }];
      }
    },
    vtMCellClick: function (data, title) {
      switch (data['btn']) {
        case 'Assign':
          if (data['row']) {
            var menuItem = this.vtMenuData.filter((m) => { return (m['title'] == title); })[0];
            // this.$set(menuItem, 'showPopup', true);
            // this.$set(menuItem, 'selectedRow', data['row']);
            
            console.log(data['row']);
            this.assignSelected = data['row'];
            //console.log(this.assignSelected);
            this.assignTitle = 'Assign ' + title;
            this.assignShow = true;
          } else { }
          break;
      }
    },
    vtMRowClick: function (row, title) {

    },

    //-------- Slider Methods
    vtResize: function (dir) {
      var table = this.$refs['vtTableMain'];
      var bottomTable = this.$refs['vtBottomMain'];
      var sliderH = this.$refs['vtSliderH'];
      var sliderV = this.$refs['vtSliderV'];
      switch (dir) {
        case 'horizontal':
          table['style']['width'] = (100 - (sliderH['value'] / 5)) + '%';
          break;
        case 'vertical':
          if ((sliderV['value'] / 5) < 80 && (sliderV['value'] / 5) > 30) {
            bottomTable['style']['height'] = (100 - (sliderV['value'] / 5)) + '%';
          }
          break;
      }
    },

    //-------- Utility Methods
    formatDatetoString: function (date) {
      if (typeof date == 'string') {
        //console.log(date);
        var dateF = date.replace(/\/Date\(/g, '').replace(/\)\//g, '').replace(/\-/g, '-');
        try {
          var dateFF = new Date(dateF);
          if (!(dateFF.getTime() === dateFF.getTime())) { dateFF = new Date(parseInt(dateF)); }
        } catch (e) { /*console.log(e);*/ }
      } else {
        var dateFF = date;
      }
      
      var d = ((dateFF.getDate().toString().length < 2) ? '0' : '') + dateFF.getDate().toString();
      var m = (((dateFF.getMonth() + 1).toString().length < 2) ? '0' : '') + (dateFF.getMonth() + 1).toString();
      var y = dateFF.getFullYear();
      var hh = ((dateFF.getHours().toString().length < 2) ? '0' : '') + dateFF.getHours().toString();
      var mm = ((dateFF.getMinutes().toString().length < 2) ? '0' : '') + dateFF.getMinutes().toString();

      return `${y}-${m}-${d} ${hh}:${mm}`;
    },
    formatStringtoDate: function (date) {
      var dateF = date.replace(/ /g, '/').replace(/\:/g, '/');
      var dateFF = dateF.split('/');
      return new Date(dateFF[0], (parseInt(dateFF[1]) - 1).toString(), dateFF[2], dateFF[3], dateFF[4]);
    },


    formatMinutesToHoursMin: function(totalMinutes){
      try{
        let result = '';
        result = `${totalMinutes} min`

        if(parseInt(totalMinutes) > 60){
          let hours = Math.floor(totalMinutes / 60);
          let minutes = totalMinutes % 60;
          result = `${hours} hr ${minutes} min`
        }
       return result 
      }catch(e){
        console.log(e);
      }
      
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";

*, body, html {
  box-sizing: border-box;
}

.vtMain {
  width: 100%;
  height: 100%;
  padding: 3px 3px 3px 45px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  // border: solid 1px red;
}

.vtDisplayMain {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.vtTopMain {
  width: 100%;
  height: auto;
  flex: 1;
  margin: 0 0 4px 0;  
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
}

.vtBottomMain {
  width: 100%;
  margin: 4px 0 0 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
}

.vtBottomMenu {
  width: auto;
  height: 100%;
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: scroll;
}

.vtMapMain {
  width: auto;
  height: 100%;
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtSliderH {
  width: 100%;
  height: 100%;
  position: absolute;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  outline: none;
  cursor: ew-resize;
}

.vtSliderH::-webkit-slider-thumb {
  width: 1px;
  height: 1px;
  -webkit-appearance: none;
  background-color: #0000;
  background: #0000;
  border: none;
}

.vtSliderH::-moz-range-thumb {
  -moz-appearance: none;
  background-color: #0000;
  background: #0000;
  border: none;
}

.vtSliderV {
  width: 90vh;
  height: 95vw;
  position: absolute;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: transparent;
  outline: none;
  cursor: ns-resize;
  transform: rotate(90deg);
  z-index: 1;
}

.vtSliderV::-webkit-slider-thumb {
  width: 1px;
  height: 1px;
  -webkit-appearance: none;
  background-color: #0000;
  background: #0000;
  border: none;
}

.vtSliderV::-moz-range-thumb {
  -moz-appearance: none;
  background-color: #0000;
  background: #0000;
  border: none;
}

.vtSliderHBarH {
  width: 3px;
  height: 100%;
  background-color: #333;
  border: solid 1px #333;
  pointer-events: none;
  z-index: 1;
}

.vtSliderHBarV {
  width: 100%;
  height: 3px;
  background-color: #333;
  border: solid 1px #333;
  pointer-events: none;
  z-index: 1;
}

.vtTableMain {
  height: 100%;
  position: relative;
  border-right: solid 1px #999;
  overflow: hidden;
  z-index: 1;
}

.vtTableMainLoader {
  width: auto;
  height: auto;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0008;
  z-index: 10;
}

.vtTableMainLoaderText {
  width: auto;
  height: 40px;
  padding: 0 4px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 0 8px #0008;
  border-radius: 4px;
  user-select: none;
}

.vtTable {
  width: 100%;
  min-width: 380px;
  position: absolute;
  top: 0px;
  bottom: 0px;
}

.vtMap {
  height: 100%;
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-left: solid 1px #999;
  overflow: hidden;
  z-index: 1;
}

.vtControlsMain {
  width: auto;
  height: 100%;
  margin: 0 4px 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.vtLegendBox {
  width: 130px;
  padding: 2px;
  position: absolute;
  left: 5px;
  bottom: 5px;
  background-color: #fff;
  box-shadow: 0 0 5px #000;
  border-radius: 5px;
  z-index: 2;
}

.vtLegendItem {
  height: 30px;
  padding: 0 2px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.veLegendIcon {
  width: 25px;
  height: 25px;
}

.vtLegendTitle {
  margin: 0 0 0 10px;
  font-size: 10px;
  white-space: nowrap;
}

.vtMapViewResetMain {
  width: 130px;
  height: 30px;
  padding: 4px;
  position: absolute;
  left: 5px;
  bottom: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 0 5px #000;
  border-radius: 5px;
  z-index: 2;
}

.vtMapViewResetBtn {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vtRefreshMain {
  width: 130px;
  height: 55px;
  padding: 2px 3px;
  margin: 2px 0 0 0;
  position: absolute;
  left: 5px;
  bottom: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0 0 5px #000;
  border-radius: 5px;
  z-index: 2;
}

.vtRefreshTitle {
  width: 100%;
  height: 100%;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
}

.vtRefreshDropdown {
  width: 100%;
  height: 100%;
  padding: 0 5px;
  font-size: 11px;
  text-align: left;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #b3c4ff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.vtRefreshDropdown:hover {
  background-color: #c4d0fd;
}

.vtRefreshDropdown::-ms-expand {
  display: none;
}

.gMapMain {
  width: 100%;
  height: 100%;
}

.vtPTMain {
  width: 100%;
  height: 100%;
  padding: 10px;
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000048;
  z-index: 255;
}

.vtPTDisplay {
  width: 100%;
  height: 100%;
  max-width: 500px;
  max-height: 600px;
  padding: 0 0 5px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #eaeaea;
  border-radius: 5px;
}

.vtPTHeader {
  width: 100%;
  height: 40px;
  padding: 0 5px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f24a01;
  color: #fff;
  border-radius: 5px 5px 0 0;
}

.vtPTContent {
  width: 100%;
  padding: 10px 5px 0 5px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 0 0 5px 5px;
  overflow-y: scroll;
  white-space: nowrap;
}

.vtPTInfoMain {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.vtPTInfoRow {
  width: 100%;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtPTInfoTitle {
  font-weight: bold;
}

.vtPTInfoValue{
  text-align: right;
}


.vtPTItem {
  width: 100%;
  margin: 2px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #fff;
  border: solid 1px black;
}

/* Map Pop Up */
.vtMapPopUpMain {
  width: 100%;
  padding: 10px 40px;
  position: absolute;
  top: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0008;
  z-index: 3;
}

.vtMapPopUp {
  width: 100%;
  min-width: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 5px;
}
.vtMapPopUpHeader {
  width: 100%;
  height: 36px;
  padding: 0 5px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e6e6e6;
  border-radius: 5px 5px 0 0;
}

.vtMapPopUpControls {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtMapPopUpBtn {
  width: auto;
  height: 28px;
  margin: 0 0 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vtMapPopUpContent {
  width: 100%;
  height: auto;
  padding: 5px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: scroll;
  overflow-x: hidden;
}

.vtMapPopUpContentDetails {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtMapPopUpContentCol {
  width: 100%;
  max-width: 48%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.vtMapPopUpContentRow {
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtMapPopUpContentTitle {
  width: 130px;
  height: 100%;
  margin: 0 5px 0 0;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vtMapPopUpContentValue {
  width: auto;
  height: 100%;
  font-size: 12px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vtMapAssignMain {
  width: 100%;
  height: auto;
  margin : 4px 0 0 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vtMapAssign {
  width: auto;
  height: 100%;
  flex: 1;
}

.vtMapAssignTitle {
  width: 100%;
  height: 30px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #e6e6e6;
}

.vtMapAssignContent {
  width: 100%;
  height: auto;
  padding: 5px;
  flex: 1;
}

.vtMapPopUpMsgMain {
  width: 100%;
  height: 36px;
  padding: 3px;
  border-radius: 0 0 5px 5px;
}

.vtMapPopUpMsg {
  width: 100%;
  height: 100%;
  padding: 0 4px;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: solid 1px rgba(255, 246, 121, 0.37);
  border-radius: 0 0 3px 3px;
}


/* -- Multi Table -- */
.vtMultiTableMain {
  width: auto;
  height: 100%;
  margin: 0 0 0 4px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.vtMultiTable {
  width: 100%;
  min-width: 600px;
  height: 100%;
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vtMTable {
  width: 100%;
  height: 100%;
  flex: 1;
}

.vtMultiTableNoSelect {
  width: 100%;
  height: 100%;
  margin: 0 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0008;
}

.vtMultiTableNoSelectTitle {
  width: 200px;
  height: 80px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 4px;
  user-select: none;
}

/* -- Assign CSS -- */
.assignPopUp {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0004;
  z-index: 255;
}

.assignMain {
  width: 80%;
  min-width: 600px;
  max-width: 800px;
  height: 80%;
  min-height: 400px;
  max-height: 500px;
  box-shadow: 0 0 8px #0008;
  border-radius: 4px;
}


</style>